module.exports = __webpack_public_path__ + "img/full.b77f2789.svg";